import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ArrowBack } from "@mui/icons-material";
import { useMediaQuery } from "@mui/material";
import { enqueueSnackbar } from "notistack";
import { forgot_password_api, login } from "../../DAL/auth/login";

export default function ForgotPassword() {
  const [forgotStates, setForgotStates] = useState({
    email: "",
  });
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const handleChange = (e) => {
    setForgotStates({ ...forgotStates, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const forgot_post_data = {
      email: forgotStates.email,
    };
    setLoading(true);
    const response = await forgot_password_api(forgot_post_data);
    console.log(response, "responseresponseresponse");
    if (response.code === 200) {
      enqueueSnackbar(response.message, { variant: "success" });
      navigate("/otp", {
        state: { email: forgotStates.email },
      });
      setLoading(false);
    } else {
      enqueueSnackbar(response.message, { variant: "error" });
      setLoading(false);
    }
  };
  const isMobile = useMediaQuery("(max-width:600px)");

  return (
    <div className="container login_page">
      <div className="mt-4"> </div>

      <div className="row justify-content-center">
        {" "}
        <Link
          className="back-to-llogin"
          style={{
            color: "#fff",
            textDecoration: "none",
            marginTop: "60px", // Added margin-top
            marginRight: "40px",
          }}
          to={"/login"}
        >
          <ArrowBack
            sx={{
              marginRight: "5px",
              color: "white",
              marginLeft: isMobile ? "17px" : "",
            }}
            className="arrow-mui"
          />
          Back To Login? Login
        </Link>
        <div className="col-12 col-md-4 login-box">
          {/* <div className="login-box"> */}
          <h2 className="login-title">Forgot Password?</h2>
          <p
            className="login-subtitle"
            // style={{
            //   font: "Montserrat",
            //   fontSize: "15px",
            //   fontWeight: "400px",
            //   lineHeight: "21.94px",
            // }}
          >
            Enter your email and we’ll help you reset your password.
          </p>
          <form onSubmit={handleSubmit}>
            <div className="input-group ">
              <label className="mb-1">Enter your email*</label>

              <input
                required
                style={{ borderRadius: "5px", marginBottom: "15px" }}
                type="email"
                placeholder="Email*"
                className="input-field"
                name="email"
                onChange={handleChange}
              />
            </div>

            <button type="submit" className="large-button-contained">
              {loading ? "Resetting..." : "Reset password"}
            </button>
          </form>

          {/* </div> */}
        </div>
      </div>
    </div>
  );
}
